module.exports = __webpack_public_path__ + "img/justify-left.00d18f63.svg";